import styled from 'styled-components'

export const HomeMainDiv = styled.div`
  padding: 10px;
  margin-right: 20px;
  font-size: 15px;
  color: ${props => props.color};
  border-radius: 4px;
  background-color: ${props => props.bgColor};
  margin-top: 0px;
`
